import { Get } from '../request'

export const fetchGroup = ({ groupId, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Get(`/groups/${groupId}`, config)
}

export const fetchGroupMembers = ({ groupId, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Get(`/groups/${groupId}/members`, config)
}
